var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-list m-content"},_vm._l((_vm.categoryList),function(row,key){return _c('categoryItem',{key:key,attrs:{"icon":row.icon,"ja":row.title,"en":row.sub_title,"url":row.id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }